import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FlowMeterData, FlowMeterBatchDataLoader, Tractor, durationToHoursStr, durationToStr} from 'shared';
import {Subscription} from 'rxjs';
import {delay, first} from 'rxjs/operators';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';

const duration = (value) => {
  return durationToHoursStr(value) + ' h';
};

@Component({
  selector: 'app-flow-meter-metrics',
  templateUrl: './flow-meter-metrics.component.html',
  styleUrls: ['./flow-meter-metrics.component.scss']
})
export class FlowMeterMetricsComponent implements OnInit, OnDestroy {
  @Input()
  loader: FlowMeterBatchDataLoader;

  private loaderSub: Subscription;
  flowMeterData: FlowMeterData;

  @Input()
  selected: Tractor[];

  dict: { tractor: Tractor, flowMeterData: FlowMeterData }[] = [];

  ds: DataSource;
  store: ArrayStore;

  isLoading = true;

  @Input()
  width: number;

  @Input()
  height: number;
  current: Tractor;

  constructor() {
  }

  ngOnInit(): void {

    this.store = new ArrayStore({
      data: [],
    });
    this.ds = new DataSource({
      paginate: false,
      store: this.store,
    });

    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      if (this.loader.isEmpty()) {
        return;
      }
      if (isLoading) {
        this.clean();
        return;
      }

      this.current = this.selected[0];
      this.flowMeterData = this.dict.find(d => d.tractor.id === this.current.id)?.flowMeterData;

      this.loader.data.forEach((flowMeterData: FlowMeterData) => {
        const tractor = this.selected.find(t => t.id === flowMeterData.vehicle_id);
        if (tractor) {
          const obj = {tractor, flowMeterData};
          this.store.insert(obj);
          this.dict.push(obj);
        }
      });
      this.ds.reload();
      /*      this.flowMeterData = this.loader.data;
            this.flowMeterData.data.forEach(d => {
              this.store.insert(d);
            });
            this.ds.reload();*/
    });
  }

  private clean() {
    this.flowMeterData = null;
    this.dict = [];
    this.store.clear();
    this.ds.reload();
  }

  valueAxisAddUnit(label) {
    return label.value.toFixed(2) + ' L';
  }

  valueAxisAddUnitLh(label) {
    return label.value.toFixed(2) + ' L/h';
  }

  valueAxisAddUnitC(label) {
    return label.value.toFixed(2) + ' C°';
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }

  onValueChanged($event: any) {
    this.flowMeterData = this.dict.find(d => d.tractor.id === this.current.id)?.flowMeterData;
  }

  durationToHoursStr(cellInfo) {
    return durationToHoursStr(cellInfo.value);
  }

  durationToStr(cellInfo) {
    return durationToStr(cellInfo.value);
  }
}
